import { Button, Modal, Text } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import styles from './ConfirmationModal.module.css';

export const SuccessModal = ({
  showSuccessModal,
  onCloseModalConfirmation,
}: {
  showSuccessModal: boolean;
  onCloseModalConfirmation: () => void;
}) => {
  const { getTranslation } = useTranslate();
  return (
    <Modal
      show={showSuccessModal}
      onClose={onCloseModalConfirmation}
      className={styles.width480}
      closeOnBackdropClick
    >
      <Modal.Header>
        {getTranslation('tickbox_success_modal_title')}
      </Modal.Header>
      <Modal.Body>
        <Text textStyle={Text.Style.BodyLgRegular}>
          {getTranslation('tickbox_success_modal_description')}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button fullWidth onClick={onCloseModalConfirmation}>
          {getTranslation('common_close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
